import React from "react";
import { MainHeader } from "../components/global/MainHeader";
import CartItemSection from "../components/Cart/CartItemSection.jsx";
import { Socials } from "../components/Home/Socials";

const Cart = () => {
  return (
    <React.Fragment>
      <MainHeader name={"Cart"} />
      <CartItemSection />
      <Socials imgSrc={"SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};

export default Cart;
